import React from 'react';

export const DecisionHeader = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.96126 8.12012L33.5262 10.4442"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M14.6812 35.8857H25.8059"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M5.47396 28.2112H15.474L11.8981 8.66908L9.12997 8.45751L5.47396 28.2112Z"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.0135 29.9807H35.0135L31.4377 10.4386L28.6695 10.227L25.0135 29.9807Z"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.2437 7.16406L20.2437 35.8856"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
